import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEditIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.79297L14.7071 4.50008L8.04044 11.1667H5.33333V8.45964L12 1.79297ZM6.33333 8.87385V10.1667H7.62623L13.2929 4.50008L12 3.20718L6.33333 8.87385ZM2 2.50008H8V3.50008H3V13.5001H13V8.50008H14V14.5001H2V2.50008Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgEditIcon);
export default ForwardRef;
